import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { OneToMany } from 'typeorm';

export class LotCodesRequest {
  @ApiProperty()
  @IsOptional()
  saleOrderId: number;

  @ApiProperty()
  @IsOptional()
  saleOrderItemId: number;

  @ApiProperty()
  @IsOptional()
  plantId: number;

}
